import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

import { Store } from '@ngrx/store';
import { Observable, map, mergeMap } from 'rxjs';

import { IBetslipRootState } from '../../../../base/store/state';
import { BetslipType } from '../../../../core/betslip-type';
import { PickId } from '../../../../core/picks/pick-id';
import { RewardTokenContext } from '../../../reward-tokens/reward-tokens.model';
import { SummaryErrorsViewModel } from '../../../validation/components/common/errors-container.component';
import { selectSinglePickErrorStateFactory } from '../../../validation/selectors';
import { ErrorViewModelService } from '../../../validation/services/error-viewmodel.service';

@Component({
    selector: 'bs-single-pick-errors',
    template: `
        @if (viewModel$ | async; as vm) {
            <bs-errors-container [viewModel]="vm" [tokensContext]="tokensContext" (errorDisplayChange)="errorDisplayChange.emit($event)" />
        }
    `,
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class SinglePickErrorsComponent implements OnInit {
    @Output() errorDisplayChange = new EventEmitter<boolean>();
    @Input() pickId: PickId;

    tokensContext: RewardTokenContext;

    viewModel$: Observable<SummaryErrorsViewModel>;

    constructor(
        private store: Store<IBetslipRootState>,
        private viewModelService: ErrorViewModelService,
    ) {}

    ngOnInit(): void {
        const betslipType = BetslipType.Single;

        const errors$ = this.store
            .select(selectSinglePickErrorStateFactory(this.pickId))
            .pipe(mergeMap(({ errors, stake }) => this.viewModelService.getErrorViewModelsForSlip$(errors, stake?.actualStake ?? null)));

        this.viewModel$ = errors$.pipe(
            map((errors) => ({
                errors,
                betslipType,
            })),
        );

        this.tokensContext = {
            betslipType: BetslipType.Single,
            pickId: this.pickId,
        };
    }
}
